import { render, staticRenderFns } from "./RoleTree.vue?vue&type=template&id=d87bdd08&scoped=true"
import script from "./RoleTree.vue?vue&type=script&setup=true&name=RoleTree&lang=js"
export * from "./RoleTree.vue?vue&type=script&setup=true&name=RoleTree&lang=js"
import style0 from "./RoleTree.vue?vue&type=style&index=0&id=d87bdd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87bdd08",
  null
  
)

export default component.exports